import { Node, Text } from 'slate';
export var Utils = {
  pathNormalize: function pathNormalize(originalPath) {
    var oldPath = originalPath.split('/');
    var newPath = [];

    for (var i = 0; i < oldPath.length; i++) {
      if (oldPath[i] === '.' || oldPath[i] === '') {
        continue;
      } else if (oldPath[i] === '..') {
        newPath.pop();
      } else {
        newPath.push(oldPath[i]);
      }
    }

    return newPath.join('/');
  }
};
export var isEmptyParagraph = function isEmptyParagraph(node) {
  if (node.type !== 'paragraph') return false;

  if (node.children.length === 1 && Text.isText(node.children[0]) && Node.text(node).length === 0) {
    return true;
  }

  return false;
};